import { render, staticRenderFns } from "./SaleFilterMenu.vue?vue&type=template&id=0593bc64&scoped=true&"
import script from "./SaleFilterMenu.vue?vue&type=script&lang=js&"
export * from "./SaleFilterMenu.vue?vue&type=script&lang=js&"
import style0 from "./SaleFilterMenu.vue?vue&type=style&index=0&id=0593bc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0593bc64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
